module.exports = __webpack_public_path__ + "static/media/Krookodile_gaussian2.682c4dbf.png";